import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { MODULE_USER } from "shared/constants";
import PermissionDeniedPage from "components/PermissionDenied";

const User = React.lazy(() => import("containers/ConfigCms/User"));

function UserRoute() {
  return (
    <Route
      path="user"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<User />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_USER]}
          />
        </Suspense>
      }
    />
  );
}

export default UserRoute;
